import { ApiType } from "@gymflow/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { memberAsMemberQueryKeys } from "./memberAsMemberQueryKeys";

export function useMutationMemberEditAsMemberNew({ api }: { api: ApiType }) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (params: {
      patchedFields?: Parameters<ApiType["profileApi"]["update"]>[0];
      picture?: Parameters<ApiType["profileApi"]["updatePicture"]>[0];
    }) => {
      const promises = [] as Promise<any>[];
      if (params.patchedFields) {
        promises.push(api.profileApi.update(params.patchedFields));
      }
      if (params.picture) {
        promises.push(api.profileApi.updatePicture(params.picture));
      }
      await Promise.all(promises);
    },
    onSuccess: async () =>
      await queryClient.invalidateQueries({
        queryKey: memberAsMemberQueryKeys.all(),
      }),
  });
}
